export const licenseCheckAnalyticsCardStatuses = ['expired', 'notVerified', 'verified', 'failed'];
